import { FC } from 'react';
import { Field } from 'react-final-form';
import { conditionalCountryRequired } from '../../helpers';
import FormError from '../Common/FormError';

const BorrowerBvnNin: FC = () => {
  return (
    <>
      <label className='form-label'>Please Enter Your Verification Details. Skip This Step If You're Not From Nigeria</label>
      <div className='mb-5 col-lg-12'>
        <Field name='bvn' type='number'>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' placeholder='BVN' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
      <div className='mb-5 col-lg-12'>
        <Field name='nin' type='number'>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' placeholder='NIN' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
    </>
  );
};

export default BorrowerBvnNin;
